import { buildModelManager } from "../builder.js";
const DefaultQaWorkflowSelection = {
  __typename: true,
  id: true,
  billingPolicyConfig: true,
  clinicalPolicyConfig: true,
  compliancePolicyConfig: true,
  createdAt: true,
  createdById: true,
  institution: true,
  intakeConfig: true,
  knowledgeBaseConfig: true,
  lastModifiedById: true,
  name: true,
  notificationConfig: true,
  operatorEmails: true,
  productLabel: true,
  reportStyleConfig: true,
  requiredMappingRules: true,
  reviewerEmails: true,
  status: true,
  updatedAt: true,
  workflowPolicyConfig: true
};
const modelApiIdentifier = "qaWorkflow";
const pluralModelApiIdentifier = "qaWorkflows";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaWorkflowSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaWorkflowSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaWorkflowSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaWorkflowSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaWorkflowSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaWorkflowSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaWorkflowSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaWorkflowGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaWorkflowManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaWorkflowSelection,
  operations
);
export {
  DefaultQaWorkflowSelection,
  QaWorkflowManager
};
//# sourceMappingURL=QaWorkflow.js.map
